// istanbul ignore file
import React from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import PropTypes from 'prop-types';

// NB: for hoc API, see default export at end of file
const handleError = (ErrorComponent, NotFoundComponent, PageComponent) => {
  const HandleError = ({
    is500Error,
    is404Error,
    displayMessage,
    cookieContent,
    searchLink,
    cartLink,
    ...rest
  }) => {
    if (is500Error) {
      return (
        <ErrorComponent
          cookieContent={cookieContent}
          searchLink={searchLink}
          cartLink={cartLink}
          displayMessage={displayMessage}
          {...rest}
        />
      );
    } else if (is404Error) {
      return (
        <NotFoundComponent
          cookieContent={cookieContent}
          searchLink={searchLink}
          cartLink={cartLink}
          displayMessage={displayMessage}
          {...rest}
        />
      );
    }

    return <PageComponent />;
  };

  HandleError.propTypes = {
    is500Error: PropTypes.bool,
    is404Error: PropTypes.bool,
    displayMessage: PropTypes.string,
    cookieContent: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      termsURL: PropTypes.string,
      termsDescription: PropTypes.string,
      dismissText: PropTypes.string,
    }),
    searchLink: PropTypes.string,
    cartLink: PropTypes.string,
  };

  return HandleError;
};

const mapErrorStateToProps = state => ({
  is500Error: R.path(['status', 'is500Error'], state),
  is404Error: R.path(['status', 'is404Error'], state),
  displayMessage: R.path(['status', 'displayMessage'], state),
  cookieContent: R.path(['content', 'cookie'], state),
  homeLink: R.path(['content', 'navigation', 'homeLink'], state),
  searchLink: R.path(['content', 'navigation', 'searchLink'], state),
  cartLink: R.path(['content', 'navigation', 'cartLink'], state),
});

export default (ErrorComponent, NotFoundComponent) => PageComponent =>
  connect(mapErrorStateToProps)(handleError(ErrorComponent, NotFoundComponent, PageComponent));
